import { Control, Controller, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import React from 'react'
import { msgid, ngettext, t } from 'ttag'
import { FormData } from '../../ChallengeAdmin'
import YumField from '../../../../components/YumInput/YumInput'
import InputAdornment from '@material-ui/core/InputAdornment'

import { ReactComponent as DailyGoalActiveIcon } from '../../../../assets/v3/icons/daily-goal-active.svg'
import { ReactComponent as DailyGoalInactiveIcon } from '../../../../assets/v3/icons/daily-goal-inactive.svg'
import { CustomTypeCategory, getCustomUnitShortTextById } from '../../../../services/CustomTypes'
import { totalMaxLabel } from '../../../ChallengeInfo/ChallengeInfo'

interface ChallengePointsUnitFieldProps {
  control: Control<FormData, any>
  watch: UseFormWatch<FormData>
  name: any
  unitFieldName: any
  dailyGoalError: boolean
  isCustom: boolean
  isSimple: boolean
  index: number
}

export default function ChallengePointsTotalMaxField(props: ChallengePointsUnitFieldProps) {
  const { control, watch, name, unitFieldName, dailyGoalError, isCustom, index, isSimple } = props

  //const manualEntryEnabled = watch('manualEntryEnabled')
  //const simpleManualEntry = watch(name)
  const value = watch(name)
  const unit = watch(unitFieldName)
  let unitName = getCustomUnitShortTextById(unit)

  if (isCustom) {
    unitName = watch(`challengePoints.${index}.customUnitName`)
  }

  if (isSimple) {
    unitName = ngettext(msgid`day`, `days`, value && value > 1 ? parseInt(value) : 1)
  }

  //const required = (manualEntryEnabled || !isAutomatedType(unit)) && simpleManualEntry
  //const showError = required && dailyGoalError
  const showError = dailyGoalError

  return (
    <Controller
      name={name}
      rules={{
        min: 1,
        //required,
      }}
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          shrink
          label={totalMaxLabel}
          type="number"
          inputProps={{
            inputMode: 'numeric',
            step: 1, // Prevent browsers from suggesting decimals
            onKeyDown: (e: any) => {
              if (e.key === '.' || e.key === ',' || e.key === '-' || e.key === '+') {
                e.preventDefault() // Block decimal points
              }
            },
          }}
          inputRef={ref}
          error={showError}
          onWheel={(e: { target: { blur: () => any } }) => e.target.blur()}
          InputProps={
            unitName && {
              endAdornment: (
                <InputAdornment style={{ flexShrink: 0, pointerEvents: 'none' }} position="end" disableTypography>
                  {unitName}
                </InputAdornment>
              ),
            }
          }
          startIcon={DailyGoalInactiveIcon}
          /*startIcon={DailyGoalActiveIcon}
          startIconInactive={DailyGoalInactiveIcon}*/
          {...otherField}
        />
      )}
    />
  )
}
